import React from "react";
import FrecciaIndietro from "../../commons/FrecciaIndietro";
import Space from "../../commons/Space";
import foto from "../../images/Evidenza/Ago2.png"
import TitoloSezioni from "../../commons/TitoloSezioni";
import "./NewsPagesFoto.css"
import ScrollToTopOnMount from "../../components/ScrollToTopOnMount";
import Spa from "../Spa";
import SpaceL from "../../commons/SpaceL";
import prezzi from "../../images/News/Listino_2025_26.png";
import zumba from "../../images/News/Zumba.jpg";
import "../../styles/List.css"
import Bar_3 from "../../components/Bar_3";


function SquadraAvviso () {
    return(
        <div className="text-center">
            <ScrollToTopOnMount />
            <FrecciaIndietro indirizzo={"/news"} />
            <p className="text-center" style={{ fontSize: "22px", fontFamily: "Hammersmith One" }}>{""}</p>
            <div className="container-foto-news m-auto" style={{display: "flex", flexDirection: "column"}}>
                <img src={foto} style={{width: "100%"}}></img>
                <SpaceL />
                <div style={{fontSize: "22px"}}>
                    Per completare la nostra squadra agonistica
                    <br/>
                    selezioniamo:
                    <br/>

                    <strong>6 atleti </strong>da inserire nella squadra B
                    <div className="d-flex flex-wrap justify-content-center">
                        <ul className="custom-list">
                            <li>FEMMINE anno di nascita 2017-2016 ESO B</li>
                            <li>MASCHI anno di nascita 2016-2015 ESO B</li>
                        </ul>
                        <br/>
                    </div>
                    <strong>5 atleti </strong> da inserire nella squadra A

                    <div className="d-flex flex-wrap justify-content-center">
                    <ul className="custom-list">
                        <li>FEMMINE anno di nascita 2014 e precedenti ESO A</li>
                        <li>MASCHI anno di nascita 2013 e precedenti ESO A</li>
                    </ul>
                    </div>
                    <SpaceL/>
                    Saranno comunque valutate anche altre candidature al di fuori dei parametri sopra indicati

                    <br/>
                    Per informazioni contattare l'allenatore
                    <br/>
                    <br/>
                    Stefano Moscardi
                    <br/><span/><a style={{color: "grey"}} href="tel:3472626564">3472626564</a>

                </div>
            </div>
            <Space />

        </div>
    )
}
export default SquadraAvviso